import request from '@/api'

// 用户相关API
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/auth/info',
    method: 'get'
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/auth/password',
    method: 'post',
    data
  })
}

export function updateUserInfo(data) {
  return request({
    url: '/auth/info',
    method: 'put',
    data
  })
}
